/**
 * The surface the app is currently running on, for presence/device analytics.
 *
 * The main app reports ios | android | web | desktop. The Watch companion and
 * CarPlay run in their own runtimes/scenes, so when (and if) they send a
 * heartbeat they pass their surface explicitly — the backend accepts all six.
 */
import { Platform } from 'react-native';
import Constants from 'expo-constants';
import { isElectron, isWeb } from './platform';

export type DeviceSurface = 'ios' | 'android' | 'web' | 'desktop' | 'watch' | 'carplay';

export function getPlatformDevice(): DeviceSurface {
  if (isElectron) return 'desktop';
  if (isWeb) return 'web';
  if (Platform.OS === 'ios') return 'ios';
  if (Platform.OS === 'android') return 'android';
  return 'web';
}

/** App version for the presence row — best-effort across Expo config shapes. */
export function getAppVersion(): string | null {
  try {
    return (
      (Constants as any)?.expoConfig?.version ||
      (Constants as any)?.manifest?.version ||
      (Constants as any)?.manifest2?.extra?.expoClient?.version ||
      null
    );
  } catch {
    return null;
  }
}
